@if(!browserInited) { <bs5-placeholder-form [rows]="4" [cols]="2" /> } @else {
<div class="modal-header">
    <h4 class="modal-title">PDI 요청 WARNING</h4>
    <div class="d-flex gap-1">
        <!-- 모달 드래그 이동 -->
        @if (modalCtrl.opts.drag) {
        <button type="button" class="btn btn-light btn-sm" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle
            [disabled]="modalCtrl.state.fullscreen">
            <i class="fa-solid fa-arrows-up-down-left-right"></i>
        </button>
        }
        <!-- 모달 닫기 -->
        <button type="button" class="btn btn-light btn-sm" (click)="modalCtrl.activeModal.dismiss()">
            <i class="fa-solid fa-xmark"></i>
        </button>
    </div>
</div>
<div class="modal-body" style="height: 300px;">
    <div class="np-flex-grid-theme-3 d-flex flex-column np-flex-h100">
        <np-flex-grid-menu #flexGrid1Menu [flexGridCtrl]="flexGrid1Ctrl"></np-flex-grid-menu>
        <wj-flex-grid #flexGrid1 (initialized)="flexGrid1Ctrl.init(flexGrid1)" [itemsSource]="flexGrid1Cv"
            [allowSorting]="'MultiColumn'" [selectionMode]="'MultiRange'" [showSelectedHeaders]="'All'"
            [frozenColumns]="0" [isReadOnly]="true" [imeEnabled]="true">

            <ng-template wjFlexGridCellTemplate [cellTypeStr]="'TopLeft'">
                <span class="np-flex-grid-menu-icon" (click)="flexGrid1Menu.toggle($event)"></span>
            </ng-template>

            <ng-template wjFlexGridCellTemplate [cellTypeStr]="'RowHeader'" let-row="row">
                {{ row.index + 1 }}
            </ng-template>

            <!-- <np-flex-grid-selector2 [flexGridCtrl]="flexGrid1Ctrl"></np-flex-grid-selector2> -->

            <wj-flex-grid-column [header]="'타입'" [binding]="'type'" />
            <wj-flex-grid-column [header]="'메세지'" [binding]="'message'" [width]="500" />

            <wj-flex-grid-filter #flexGrid1Filter />
        </wj-flex-grid>
        <div class="np-flex-grid-footer">
            <div class="row g-0 py-1">
                <div class="col-auto d-flex align-items-center">
                    <div class="d-flex ps-2" *ngIf="flexGrid1Cv">
                        <span>전체: {{flexGrid1Cv.totalItemCount | number}}</span>
                        <span class="ps-1" *ngIf="flexGrid1Ctrl.selector">
                            | 체크: {{this.flexGrid1Ctrl.selector.selectedRows.length | number}}</span>
                        <span class="ps-1" *ngIf="flexGrid1Ctrl.currentRows">
                            | 선택: {{this.flexGrid1Ctrl.currentRows.length | number}}</span>
                    </div>
                </div>
                <div class="col"></div>
                <div class="col-auto d-flex justify-content-end align-items-center">
                    <wj-flex-grid-search #flexGridModal1Search [placeholder]="'키워드를 입력하세요 (결과 내 검색)'" [grid]="flexGrid1"
                        style="width: 300px;"></wj-flex-grid-search>
                    <button class="btn btn-sm" (click)="flexGrid1Filter.clear();flexGridModal1Search.text = ''"
                        title="필터 초기화">
                        <i class="fa-solid fa-filter-circle-xmark"></i></button>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <div class="d-flex gap-2">
        <button type="button" class="btn btn-outline-secondary" (click)="activeModal.dismiss()">닫기</button>
    </div>
</div>
}